import React, { useCallback, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import PicklistField from 'core/components/validatedForm/DropdownField'
import ModalForm from 'core/elements/modal/ModalForm'
import Text from 'core/elements/Text'
import useParams from 'core/hooks/useParams'
import useUpdateAction from 'core/hooks/useUpdateAction'
import Theme from 'core/themes/model'
import { addServerGroupVirtualMachine } from './actions'
import ServerGroupsPicklist from './server-groups/ServerGroupsPicklist'

interface ServerGroup {
  id: string
  name: string
  policy: string
  rules: Record<string, unknown>
  members: string[]
  project_id: string
  user_id: string
}

const useStyles = makeStyles<Theme>((theme) => ({
  fields: {
    gap: theme.spacing(2),
    display: 'grid',
    paddingBottom: theme.spacing(4), // To leave some room for the dropdown
  },
}))

export default function AddServerGroupDialog({ rows: vms, onClose }) {
  const defaultParams = {
    serverGroup: {
      id: null,
      name: '',
      policy: '',
      rules: {},
      members: [],
      project_id: '',
      user_id: '',
    },
  }
  const classes = useStyles()
  const { params, getParamsUpdater } = useParams(defaultParams)
  const [error, setError] = useState<{ message: string } | null>(null)
  const { update: updateFn, updating: submitting } = useUpdateAction(addServerGroupVirtualMachine)

  const handleSubmit = useCallback(async () => {
    setError(null)
    try {
      const vm = vms?.[0]
      const body = {
        addToServerGroup: {
          group_id: params?.serverGroup?.id,
        },
      }

      const result = await updateFn({ id: vm?.id, body })
      if (result?.success) {
        onClose(true)
      } else {
        setError({
          message:
            result?.error?.response?.data?.forbidden?.message ||
            result?.error?.response?.data?.itemNotFound?.message ||
            result?.error?.response?.data?.message ||
            result?.error?.message ||
            'Something went wrong, please try again.',
        })
      }
    } catch (err) {
      setError({
        message: err?.message || 'Something went wrong. Please try again.',
      })
    }
  }, [vms, updateFn, onClose, params])

  return (
    <ModalForm
      title="Add Server Group"
      onSubmit={handleSubmit}
      onClose={onClose}
      submitting={submitting}
      error={error}
      submitTitle="Add Server Group"
      panel="dialog"
      open
    >
      <div className={classes.fields}>
        <Text variant="body2">
          The VM <b>{vms?.[0]?.name}</b> will be added to the selected server group
        </Text>

        <PicklistField
          id="serverGroup"
          DropdownComponent={ServerGroupsPicklist}
          value={params.serverGroup}
          onChange={getParamsUpdater('serverGroup')}
          required
        />
      </div>
    </ModalForm>
  )
}
